import React, { Component } from 'react'

class TweetPage extends Component {
  render () {
    return (
      <div>
        <h1>Tweets</h1>
      </div>
    )
  }
}

export default TweetPage



// WEBPACK FOOTER //
// ./src/components/tweetpage.js